<template>
  <div style="border: 0px solid black; width:100%;display:block;">
    <div class="welcome" style="border: 0px solid red;">
      <row style="border:0px solid green;display: contents;width:100%;">
        <div class="box box-success">
          <div class="box-header with-border">
            <h3 class="box-title">{{ $t("templateNotification.list") }}</h3>
          </div>
          <div class="box-body">
            <div>
              <button
                class="btn btn-primary btn-sm pull-right"
                style="margin-left: 6px;"
                @click="onAddNewTemplate"
              >
                <i class="glyphicon glyphicon-plus"></i>
                {{ $t("common.addnew") }}
              </button>
              <button
                class="btn btn-danger btn-sm pull-right"
                style="margin-left: 6px;"
                @click="onCallbackCategory"
              >
                <i class="glyphicon glyphicon-remove"></i>
                {{ $t("common.close") }}
              </button>
            </div>
            <b-table striped hover :fields="fields" :items="items">
              <template #head()="scope">
                <div>{{ $t(scope.label) }}</div>
              </template>
              <template #cell(usedDefault)="row">
                <div v-if="row.item.usedDefault">
                  <i
                    class="glyphicon glyphicon-ok text-success"
                    style="font-size: 20px"
                  ></i>
                </div>
                <div v-else>
                  <i
                    class="glyphicon glyphicon-remove text-danger"
                    style="font-size: 20px"
                  ></i>
                </div>
              </template>
              <template #cell(actions)="row">
                <div class="btn-group">
                  <button
                    v-if="!row.item.usedDefault"
                    class="btn btn-success pull-left"
                    style="margin-left: 6px;"
                    @click="onEnableTemplate(row.item)"
                  >
                    <i class="glyphicon glyphicon-ok"></i>
                  </button>
                  <button
                    class="btn btn-primary"
                    style="margin-left: 6px;"
                    @click="onViewTemplateDetail(row.item)"
                  >
                    <i class="glyphicon glyphicon-edit"></i>
                  </button>
                  <button
                    class="btn btn-danger"
                    style="margin-left: 6px;"
                    @click="onDeleteTemplate(row.item)"
                  >
                    <i class="glyphicon glyphicon-trash"></i>
                  </button>
                </div>
              </template>
            </b-table>
          </div>
          <div class="box-footer clearfix">
            <paginator :item="paginatorItem" @onpaginate="onPagination" />
          </div>
        </div>
      </row>
    </div>
    <!--  -->
    <lte-modal
      v-show="isModalVisible"
      @onConfirm="onConfirmDeleteTemplate"
      @close="closeModal"
      v-for="obj in objModal"
      :key="obj.id"
      :item="obj"
    ></lte-modal>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import LTEModal from "@/components/LTEModal.vue";
import Paginator from "@/components/Paginator.vue";
import utils from '@/lib/utils';

export default {
  components: {
    "lte-modal": LTEModal,
    paginator: Paginator
  },
  data: () => ({
    fields: [
      { sortable: false, label: "common.nonumber", key: "nonumber" },
      { sortable: false, label: "templateNotification.name", key: "name" },
      {
        sortable: false,
        label: "templateNotification.usedDefault",
        key: "usedDefault",
        class: "text-center"
      },
      {
        sortable: false,
        label: "templateNotification.category.title",
        key: "categoryName"
      },
      { sortable: false, label: "common.action", key: "actions" }
    ],
    items: [],
    templateNotificationSelect: null,
    isModalVisible: false,
    objModal: [
      {
        title: "documentation.inform_modal[0].title",
        body: "templateNotification.confirmDeleteTemplate",
        buttonNo: "documentation.inform_modal[0].modal_btn[0].cancel",
        buttonYes: "documentation.inform_modal[0].modal_btn[0].confirm",
        styleType: "default"
      }
    ],
    paginatorItem: {
      commit_function: "GET_TEMPLATE_NOTIFICATION_BY_CATEGORY"
    }
  }),
  computed: {
    ...mapGetters([
      "PAGINATION",
      "PAGINATOR",
      "PAGE_ARROW"
    ])
  },
  methods: {
    getCategoryList: function(page) {
      let categoryId = this.$route.params.categoryId;
      let filter = {
        params: {
          page: page,
          categoryId: categoryId
        }
      };
      this.GET_TEMPLATE_NOTIFICATION_BY_CATEGORY(filter).then(
        function(res) {
          this.items = [];
          let data = res.data.results;
          data.forEach((value, index) => {
            let item = {
              id: value.id,
              nonumber: index + 1 + (this.PAGINATION.page - 1) * this.PAGINATION.size,
              name: value.name,
              usedDefault: value.used_default,
              categoryName: this.getTemplateCatagoryName(value.template_category)
            };
            this.items.push(item);
          });
        }.bind(this)
      );
    },
    getTemplateCatagoryName(category) {
      return this.$t(utils.getTemplateCatagoryName(category))
    },
    // onViewTemplate: function(data) {
    //   let categoryId = this.$route.params.categoryId;
    //   this.$router.push({
    //     name: "TemplateNotification",
    //     params: {
    //       categoryId: categoryId
    //     }
    //   });
    // },
    onCallbackCategory: function() {
      this.$router.push({
        name: "NotificationCategory"
      });
    },
    onAddNewTemplate: function() {
      let categoryId = this.$route.params.categoryId;
      this.$router.push({
        name: "TemplateNotificationDetail",
        params: {
          categoryId: categoryId,
          id: 0
        }
      });
    },
    onEnableTemplate: function(data) {
      let template = {
        id: data.id,
        categoryId: this.$route.params.categoryId
      };
      this.ENABLE_TEMPLATE_NOTIFICATION(template)
        .then(
          function() {
            this.getCategoryList(1);
          }.bind(this)
        )
        .catch(
          function(error) {
            let message = error.response.data.message;
            this.showError(message);
          }.bind(this)
        );
    },
    onDeleteTemplate: function(data) {
      this.templateNotificationSelect = data;
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    onConfirmDeleteTemplate: function() {
      const payload = {
        id: this.templateNotificationSelect.id
      };
      this.DELETE_TEMPLATE_NOTIFICATION(payload)
        .then(
          function() {
            this.isModalVisible = false;
            this.getCategoryList(1);
          }.bind(this)
        )
        .catch(
          function(error) {
            let message = error.response.data.message;
            this.showError(message);
          }.bind(this)
        );
    },
    onViewTemplateDetail: function(data) {
      let categoryId = this.$route.params.categoryId;
      this.$router.push({
        name: "TemplateNotificationDetail",
        params: {
          categoryId: categoryId,
          id: data.id
        }
      });
    },
    //
    onPrevPagination: function() {
      const data = {
        url: this.PAGE_ARROW.prev,
        commit_funtion: "GET_TEMPLATE_NOTIFICATION_BY_CATEGORY"
      };
      this.PAGINATION_PREV_PAGE(data);
    },
    onNextPagination: function() {
      const data = {
        url: this.PAGE_ARROW.next,
        commit_funtion: "GET_TEMPLATE_NOTIFICATION_BY_CATEGORY"
      };
      this.PAGINATION_NEXT_PAGE(data);
    },
    onPagination: function(data) {
      this.getCategoryList(data.params.page)
    },
    ...mapActions([
      "GET_TEMPLATE_NOTIFICATION_BY_CATEGORY",
      "ENABLE_TEMPLATE_NOTIFICATION",
      "DELETE_TEMPLATE_NOTIFICATION",
      "PAGINATION_PREV_PAGE",
      "PAGINATION_NEXT_PAGE"
    ])
  },
  created() {
    this.getCategoryList(1);
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Notification/TemplateNotification.vue